<template>
  <div class="carbox_container">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div style="padding-top:50px;">
      <div v-if="interestUser.length != 0">
        <!--头部图标-->
        <div class="topiconbox">
          <div class="toppicicon" v-for="item in interestUser">
            <div :data-id="item.id" @click="linktoMessage">
              <img :src="item.avatar_url" />
            </div>
            <p v-if="item.name">{{item.name}}</p>
            <p v-else>默认昵称</p>
            <button class="circle-cell-fllow" v-if="item.is_follower == 0" @click="handleFocus" :data-id="item.id">关注</button>
            <button class="circle-cell-fllow circle-cell-fllow-active" v-else @click="handleFocus" :data-id="item.id">已关注</button>
          </div>
        </div>
        <!-- 名片列表 -->
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="indexes" style="background-color:#f8f8f8;">
            <div class="indexes-title"><span>热门名片</span></div>
            <div class="cu-list menu-avatar">
              <div v-for="(cell,index) in hotCard" :key="index">
                <div class="cu-item item-bottomline" :data-id="cell.id" @click="linktoMessage">
                  <!-- 默认头像判断 -->
                  <div v-if="cell.avatar_url" class="cu-avatar round lg" :style="'background-image:url('+cell.avatar_url+');'"></div>
                  <div v-else class="cu-avatar round lg" :style="'background-image:url('+guideIconSlider+');'"></div>
                  <div style="width:12.8rem">
                    <div class="text-grey texts-messages">
                      <span class="texts-names">{{cell.name}}</span>
                    </div>
                    <div class="text-gray text-sm texts-company">{{cell.company_name}} <span v-if="cell.job_title">|</span> {{cell.job_title}}</div>
                  </div>
                  <div class="circle-cell-info">
                    <img :src="circleIconShang" alt="">
                    <span>{{cell.fans_num}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="nofollowbox" v-else>
        <div class="nofollowpic">
          <img :src="nofollowpicIcon" />
        </div>
        <div class="nosearchtext">暂无名片</div>
      </div>
    </div>
  </div>
</template>

<script>
import { findSomeone, getclickfollow } from "../../api/api";
import navbar from "../public/navbar.vue";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
export default {
  name: "findperson",
  components: { navbar },
  data () {
    return {
      titlename: "找人",
      cartslist: [],
      hotCard: [],
      interestUser: [],
      page: 0,
      pageCount: 0,
      nofollowpicIcon: require("../../assets/images/circle_icon_wu.png"),
      guideIconSlider: require("../../assets/images/guide_icon_slider.png"),
      circleIconShang: require("../../assets/images/circle_icon_shang.png"),
      loading: false,
      finished: false,
    };
  },
  created () {
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    this.initCartList();
  },
  activated () {
    this.initCartList();
  },
  methods: {
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        this.loading = false;
        if (page >= pageCount) {
          this.loading = false;
          this.finished = true;
          return;
        }
        this.page = page;
        let json = {
          page: page
        };
        findSomeone(json).then(res => {
          if (res.data.code == 200) {
            let mytjcirclearr = that.hotCard;
            let newarr = res.data.data.hotCard.list;
            newarr.forEach(function (e) {
              mytjcirclearr.push(e);
            });
          }
        });
      }, 500);
    },
    //获取名片列表
    initCartList () {
      let json = {
        page: 0
      };
      findSomeone(json).then(res => {
        Toast.clear();
        if (res.data.code == 200) {
          this.pageCount = res.data.data.hotCard.pageCount;
          this.page = 0;
          this.hotCard = res.data.data.hotCard.list
          this.interestUser = res.data.data.interestUser
          this.finished = false;
          this.interestUser.filter(item => {
            if (item.name.length > 3) {
              item.name = item.name.slice(0, 3) + "...";
            }
          });
        }
      }).catch(err => {
        Toast.clear();
      });
    },
    //名片
    linktoMessage: function (e) {
      this.$router.push({
        path: '/othercart',
        query: {
          id: e.currentTarget.dataset.id
        }
      })
    },
    //关注
    goodFocus: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      //var cookie_mid = wx.getStorageSync('Focus') || [];
      var cookie_mid = this.$store.getters.getFocus || []; //获取全部点赞的mid
      var newmessage = [];
      for (var i = 0; i < that.interestUser.length; i++) {
        if (that.interestUser[i].id == item_id) {
          //遍历找到对应的id
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id) || that.interestUser[i].is_follower == 1) {
            //说明已经点过赞,取消赞
            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            isshow = 0; //点赞的状态
            that.interestUser[i].is_follower = isshow;
            that.$store.dispatch("changeFocusFun", cookie_mid);
          } else {
            isshow = 1; //点赞的状态
            that.interestUser[i].is_follower = isshow;
            cookie_mid.unshift(item_id); //新增赞的mid
            that.$store.dispatch("changeFocusFun", cookie_mid);
          }
          getclickfollow(item_id).then(res => {
            if (res.code == 200) {
              Toast("操作成功!");
            } else {
              Toast("操作失败!");
            }
          });
        }
      }
    },
    //关注他人
    handleFocus: function (e) {
      var item_id = e.currentTarget.dataset.id; //此处找到列表的id
      this.goodFocus(item_id);
    },
  }
};
</script>

<style scoped>
.navbar {
  position: relative;
  z-index: 99;
}
.carbox_container {
  height: 100%;
  background-color: #f8f8f8;
}
.item-bottomline {
  border-bottom: 0.02702702702702703rem solid #f8f8f8;
}
.item-bottomline:last-of-type {
  border: none;
}
.texts-messages {
  font-size: 0.6486486486486487rem;
}
.texts-names {
  color: #000;
  margin-right: 0.6486486486486487rem;
  font-family: "SimHei";
  font-size: 0.8108108108108109rem;
  margin-bottom: 0.35135135135135137rem;
}
.texts-job {
  font-size: 0.7027027027027027rem;
  color: #666;
}
.texts-company {
  width: 13rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.7027027027027027rem;
  color: #999;
  margin-top: 0.2702702702702703rem;
}
.indexes {
  position: relative;
}
.indexes-title {
  padding: 0.7rem;
  background: #fff;
}
.indexes-title span {
  display: inline-block;
  line-height: 0.75rem;
  padding: 0 0.5rem;
  font-size: 0.8108108108108109rem;
  border-left: 3px solid #ffbd0a;
}
.nofollowbox {
  padding-top: 2.7027027027027026rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.cu-list.menu-avatar .cu-item {
  position: relative;
  display: flex;
  padding-right: 0.2702702702702703rem;
  height: 3.7837837837837838rem;
  background-color: white;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
}
.cu-avatar.lg {
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
  font-size: 2em;
  border-radius: 50%;
  margin-right: 0.6486486486486487rem;
  background-size: 100%;
  background: #999;
}

.circle-cell-info {
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  width: 2.5rem;
  justify-content: flex-end;
}

.circle-cell-info img {
  width: 0.5rem;
  margin-right: 0.3rem;
}
.circle-cell-info span {
  color: #ffbd0a;
  font-size: 0.7rem;
}

.topiconbox {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  padding: 1.25rem 0.3rem;
  width: calc(100% - 0.6rem);
  margin: 0 auto;
  background: #fff;
  margin-bottom: 0.586666rem;
}
.topiconbox .toppicicon {
  flex: 0 0 20%;
}
.topiconbox .toppicicon img {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  margin: 0 auto !important;
  display: block;
}
.topiconbox .toppicicon p {
  text-align: center;
  display: block;
  color: #af7018;
  font-size: 0.8108108108108109rem;
  padding: 0.32rem 0;
}
.circle-cell-fllow {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3rem;
  height: 1.15rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
  margin: 0 auto;
}
.circle-cell-fllow-active {
  color: #ffbd0a;
  background: #fff;
  border: 1px solid #ffbd0a;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/findperson.vue